import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/legal.css";
import minutezillaLogoWhite from "../../assets/images/minutezilla-logo-white.png";

export default function Datenschutz() {
  return (
    <div className="legal-root">
      <div className="legal-topbar">
        <Link to="/login" className="legal-topbar-brand">
          <div className="legal-topbar-logo">
            <img src={minutezillaLogoWhite} alt="Minutezilla" className="legal-topbar-logo__img" />
          </div>
        </Link>
        <Link to="/login" className="legal-topbar-back">
          ← Zurück zum Login
        </Link>
      </div>

      <div className="legal-wrapper">
        <div className="legal-header">
          <div className="legal-badge">Datenschutz</div>
          <h1 className="legal-title">Datenschutzerklärung</h1>
          <p className="legal-subtitle">Informationen gemäß Art. 13 und 14 DSGVO</p>
          <p className="legal-updated">Stand: 24. Mai 2026</p>
        </div>

        <div className="legal-toc">
          <p>Inhaltsverzeichnis</p>
          <ol>
            <li><a href="#verantwortlicher">Verantwortlicher</a></li>
            <li><a href="#daten">Welche Daten verarbeitet werden</a></li>
            <li><a href="#zwecke">Zwecke und Rechtsgrundlagen</a></li>
            <li><a href="#empfaenger">Empfänger und Dienstleister</a></li>
            <li><a href="#speicherdauer">Speicherdauer</a></li>
            <li><a href="#rechte">Ihre Rechte</a></li>
            <li><a href="#cookies">Cookies und lokaler Speicher</a></li>
            <li><a href="#sicherheit">Datensicherheit</a></li>
            <li><a href="#aenderungen">Änderungen dieser Erklärung</a></li>
          </ol>
        </div>

        <div className="legal-content">
          <div className="legal-section" id="verantwortlicher">
            <h2>1. Verantwortlicher</h2>
            <div className="legal-infobox">
              <p>
                <strong>Sivaprasad Sisupalan</strong><br />
                Speckenkamp 12<br />
                38442 Wolfsburg<br />
                Deutschland<br /><br />
                E-Mail: <a href="mailto:kontakt@minutezilla.com">kontakt@minutezilla.com</a><br />
                Telefon: +49 157 79151890
              </p>
            </div>
            <p>
              Verantwortlicher im Sinne der DSGVO für diese Website und die darüber angebotenen
              Minutezilla-Dienste ist Sivaprasad Sisupalan.
            </p>
          </div>

          <div className="legal-section" id="daten">
            <h2>2. Welche Daten verarbeitet werden</h2>

            <h3>Kontaktdaten und Accountdaten</h3>
            <ul>
              <li>Name, E-Mail-Adresse und weitere freiwillig bereitgestellte Kontaktdaten</li>
              <li>Verschlüsselte Passwörter, Rollen, Workspace-Zugehörigkeiten und Einstellungen</li>
            </ul>

            <h3>Nutzungs- und App-Daten</h3>
            <ul>
              <li>Zeiterfassungs-, Projekt-, Kunden-, Anwesenheits-, Urlaubs- und Berichtsdaten</li>
              <li>Technische Daten wie IP-Adresse, Browserinformationen, Gerätedaten und Server-Logs</li>
              <li>Authentifizierungs- und Sitzungsdaten einschließlich technisch notwendiger Cookies und LocalStorage-Einträge</li>
            </ul>
          </div>

          <div className="legal-section" id="zwecke">
            <h2>3. Zwecke und Rechtsgrundlagen</h2>
            <p>
              Die Verarbeitung erfolgt insbesondere zur Bereitstellung der Website und App, zur
              Authentifizierung, zur Zeiterfassung, zur Projekt- und Teamverwaltung, zur
              Kommunikation sowie zur Sicherheit und Stabilität des Dienstes.
            </p>
            <p>
              Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. b DSGVO
              (Vertrag bzw. vorvertragliche Maßnahmen), Art. 6 Abs. 1 lit. c DSGVO
              (rechtliche Verpflichtungen), Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen)
              sowie gegebenenfalls Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
            </p>
          </div>

          <div className="legal-section" id="empfaenger">
            <h2>4. Empfänger und Dienstleister</h2>
            <p>
              Personenbezogene Daten können an technische Dienstleister übermittelt werden, soweit
              dies für den Betrieb des Angebots erforderlich ist. Dazu gehören derzeit insbesondere
              Hosting bei Hetzner, transaktionaler E-Mail-Versand über Brevo sowie optionale
              Anmeldung über Google oder Apple.
            </p>
            <p>
              Zur Reichweitenmessung wird Plausible Analytics eingesetzt. Dabei werden nach
              aktuellem Setup keine Tracking-Cookies gesetzt. Verarbeitet werden reduzierte
              Nutzungs- und Gerätedaten, um Seitenaufrufe und die Nutzung der Website statistisch
              auszuwerten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Weitere Informationen:
              {" "}
              <a href="https://plausible.io/data-policy">https://plausible.io/data-policy</a>.
            </p>
            <p>
              Soweit Dienstleister außerhalb der EU bzw. des EWR eingesetzt werden, erfolgt eine
              Übermittlung nur auf Grundlage geeigneter Garantien, etwa
              Standardvertragsklauseln nach Art. 46 DSGVO.
            </p>
          </div>

          <div className="legal-section" id="speicherdauer">
            <h2>5. Speicherdauer</h2>
            <p>
              Personenbezogene Daten werden nur so lange gespeichert, wie dies für die jeweiligen
              Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Server-Logs
              werden in der Regel nur kurzfristig zu Sicherheits- und Betriebszwecken gespeichert.
            </p>
          </div>

          <div className="legal-section" id="rechte">
            <h2>6. Ihre Rechte</h2>
            <div className="legal-highlight">
              <h3>Datenschutzrechte</h3>
              <ul>
                <li>Auskunft nach Art. 15 DSGVO</li>
                <li>Berichtigung nach Art. 16 DSGVO</li>
                <li>Löschung nach Art. 17 DSGVO</li>
                <li>Einschränkung der Verarbeitung nach Art. 18 DSGVO</li>
                <li>Datenübertragbarkeit nach Art. 20 DSGVO</li>
                <li>Widerspruch nach Art. 21 DSGVO</li>
                <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft</li>
              </ul>
            </div>
            <p>
              Zur Ausübung Ihrer Rechte können Sie jederzeit an
              <a href="mailto:kontakt@minutezilla.com"> kontakt@minutezilla.com</a> schreiben.
            </p>
            <p>
              Sie haben außerdem das Recht, sich bei einer zuständigen
              Datenschutz-Aufsichtsbehörde zu beschweren.
            </p>
          </div>

          <div className="legal-section" id="cookies">
            <h2>7. Cookies und lokaler Speicher</h2>
            <p>
              Diese Website und App verwenden technische Cookies und lokale Speichermechanismen,
              soweit dies für Login, Session-Sicherheit, Spracheinstellungen und die Nutzung der
              Anwendung erforderlich ist. Es werden derzeit keine Werbe-Tracking-Cookies eingesetzt.
            </p>
            <p>
              Je nach Nutzung können insbesondere Authentifizierungs-Cookies oder
              LocalStorage-Einträge wie <strong>persist:root</strong>, <strong>token</strong> oder
              vergleichbare anwendungsbezogene Einstellungen gespeichert werden.
            </p>
          </div>

          <div className="legal-section" id="sicherheit">
            <h2>8. Datensicherheit</h2>
            <p>
              Es werden angemessene technische und organisatorische Maßnahmen getroffen, um
              personenbezogene Daten zu schützen. Dazu gehören insbesondere verschlüsselte
              Übertragung per HTTPS/TLS, Zugriffsbeschränkungen, sichere Authentifizierung und die
              Absicherung der Server- und Datenbankumgebung.
            </p>
          </div>

          <div className="legal-section" id="aenderungen">
            <h2>9. Änderungen dieser Datenschutzerklärung</h2>
            <p>
              Diese Datenschutzerklärung kann aktualisiert werden, wenn sich rechtliche
              Anforderungen oder der Funktionsumfang des Angebots ändern. Die jeweils aktuelle
              Fassung ist auf dieser Seite abrufbar.
            </p>
          </div>
        </div>

        <div className="legal-footer-strip">
          <p>&copy; {new Date().getFullYear()} Minutezilla. Alle Rechte vorbehalten.</p>
          <div>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/agb">AGB</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
